<i class="theme-favorite-i favourite" [class.disabled]="disabled" [class.selected]="toggleClass" (click)="setToggle($event)"></i>
